import { Autocomplete, Stack, TextField, Typography } from '@mui/material'
import { UserGroup } from '@ulysses-inc/harami_api_client'
import React from 'react'
import { useSelector } from 'react-redux'
import FormikErrorMessage from 'src/components/formikErrorMessage/FormikErrorMessage'
import { RootState } from 'src/state/store'
import { TBaseFormRowProps } from './EditSchedule'

const ScheduleNotifiedGroupsRow: React.FC<TBaseFormRowProps> = ({
  setFieldValue,
  values: { userGroups },
  errors,
  touched,
}) => {
  const existingUserGroups = useSelector(
    (state: RootState) => state.usersState.userGroups.userGroups,
  )

  const handleChange = (_event: React.SyntheticEvent, value: UserGroup[]) => {
    setFieldValue('userGroups', value)
  }

  return (
    <Stack>
      <Typography variant="subtitle1" fontWeight="bold">
        通知先のユーザーグループ
      </Typography>

      <Autocomplete<UserGroup, true, false, false>
        multiple
        options={existingUserGroups ?? []}
        getOptionKey={option => String(option.id)}
        getOptionLabel={option => option.name || ''}
        value={userGroups ?? []}
        onChange={handleChange}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderInput={params => (
          <TextField
            {...params}
            error={touched.userGroups && !!errors.userGroups}
          />
        )}
        sx={{ flex: 1 }}
      />
      <Stack>
        <FormikErrorMessage
          name="userGroups"
          errors={errors}
          touched={touched}
        />
      </Stack>
    </Stack>
  )
}

export default ScheduleNotifiedGroupsRow
